// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1v2me","list":"PatternAutocomplete_list__32WcH"};